var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBsc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.166 3.00616L13.9198 2.8646L13.6721 3.00355L9.47583 5.35765L7.99067 4.51837L13.9168 1.09267L19.8268 4.50908L18.2577 5.35889L14.166 3.00616ZM20.1341 9.7382V12.2514L16.0512 14.599L15.8005 14.7432V15.0325V19.7351L13.8086 20.9472L11.8168 19.7351V14.9243V14.6351L11.566 14.4909L7.48309 12.1432V9.79874L9.47583 8.67262L13.6721 11.0267L13.9198 11.1657L14.1661 11.0241L18.2516 8.67436L20.1341 9.7382ZM23.0841 10.5674V8.53146V8.25042L22.844 8.10432L21.0541 7.01514L22.5841 6.08411L24.576 7.29618V9.65962L23.0841 10.5674ZM22.8323 18.9323L23.0831 18.7881V18.4988V13.7923L24.6831 12.7926V19.6185L18.7494 23.0486V21.2799L22.8323 18.9323ZM13.5487 24.0168L13.8086 24.1749L14.0685 24.0168L15.8005 22.9628V24.7167L13.8086 25.9288L11.8168 24.7167V22.9629L13.5487 24.0168ZM4.88936 8.09954L3.29143 9.03146H4.64229V10.5664L3.15045 9.65858V7.29612L5.14674 6.08084L6.74877 7.01514L4.88936 8.09954ZM4.74941 13.862V18.607V18.8962L5.00018 19.0404L9.08309 21.3881V23.1567L3.14941 19.7266V12.8884L4.74941 13.862ZM18.7505 18.0744V16.3961L20.2413 15.4886V17.2316L18.7505 18.0744ZM7.48309 15.3802L8.97493 16.288V18.0746L7.48309 17.2315V15.3802ZM13.8141 7.94947L12.2936 7.02426L13.9113 6.08081L15.4318 7.00601L13.8141 7.94947Z",
    fill: "url(#paint0_linear_554_1091)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.166 3.00616L13.9198 2.8646L13.6721 3.00355L9.47583 5.35765L7.99067 4.51837L13.9168 1.09267L19.8268 4.50908L18.2577 5.35889L14.166 3.00616ZM20.1341 9.7382V12.2514L16.0512 14.599L15.8005 14.7432V15.0325V19.7351L13.8086 20.9472L11.8168 19.7351V14.9243V14.6351L11.566 14.4909L7.48309 12.1432V9.79874L9.47583 8.67262L13.6721 11.0267L13.9198 11.1657L14.1661 11.0241L18.2516 8.67436L20.1341 9.7382ZM23.0841 10.5674V8.53146V8.25042L22.844 8.10432L21.0541 7.01514L22.5841 6.08411L24.576 7.29618V9.65962L23.0841 10.5674ZM22.8323 18.9323L23.0831 18.7881V18.4988V13.7923L24.6831 12.7926V19.6185L18.7494 23.0486V21.2799L22.8323 18.9323ZM13.5487 24.0168L13.8086 24.1749L14.0685 24.0168L15.8005 22.9628V24.7167L13.8086 25.9288L11.8168 24.7167V22.9629L13.5487 24.0168ZM4.88936 8.09954L3.29143 9.03146H4.64229V10.5664L3.15045 9.65858V7.29612L5.14674 6.08084L6.74877 7.01514L4.88936 8.09954ZM4.74941 13.862V18.607V18.8962L5.00018 19.0404L9.08309 21.3881V23.1567L3.14941 19.7266V12.8884L4.74941 13.862ZM18.7505 18.0744V16.3961L20.2413 15.4886V17.2316L18.7505 18.0744ZM7.48309 15.3802L8.97493 16.288V18.0746L7.48309 17.2315V15.3802ZM13.8141 7.94947L12.2936 7.02426L13.9113 6.08081L15.4318 7.00601L13.8141 7.94947Z",
    stroke: "url(#paint1_linear_554_1091)",
    style: {
      mixBlendMode: "plus-lighter"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_554_1091",
    x1: 13.9163,
    y1: 0.515137,
    x2: 13.9163,
    y2: 26.5141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_554_1091",
    x1: 13.9163,
    y1: 0.515137,
    x2: 13.9163,
    y2: 26.5141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.07
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2546_6609"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(0.916992 0.515137)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsc);
export default __webpack_public_path__ + "static/media/bsc.e422ccdcfa637aac0bc55ec83ff344ee.svg";
export { ForwardRef as ReactComponent };